// UI «Крутагидона»: хотсит (один телефон) и онлайн (комната с кодом). Мобильный интерфейс в духе Slay the Spire:
// противники сверху, стол/барахолка в центре, веер руки внизу, карты играются перетаскиванием.
// Точка входа: загрузка базы карт, установка как приложения, первый render. Остальное по модулям:
// store (состояние, окна) → render (экраны) → flow (действия, подготовка, онлайн) → bots (ходы ботов) → input (ввод).
import type { Action, CardsData, Game as GameState } from '../types.ts';
import { loadDatabase, DB } from '../engine/state.ts';
import { assertScriptsComplete } from '../engine/tokens.ts';
import { notify } from './notify.ts';
import { initInstallBanner, onAutoInstall, onInstalled } from './install.ts';
import type { UiState } from './state.ts';
import { initOutbox } from './outbox.ts';
import * as OV from './overlays.ts';
import { st, ui, $app, openModal, modalOpen, repaintModal } from './store.ts';
import { render } from './render.ts';
import { act } from './flow.ts';
import { botNow } from './bots.ts';
import { initSocial } from './social.ts';
import { initProfile } from './profile.ts';
import { initReplay } from './replay.ts';
import { loadDaily, loadMyBosses } from './daily.ts';
import { repaintSocial } from './render.ts';
import { initPush, onPushChange } from './push.ts';
import { initCorr } from './corr.ts';
import './input.ts';

declare global {
  interface Window {
    /** отладочный доступ для автотестов */
    __K?: { readonly G: GameState | null; ui: UiState; st: typeof st; render: () => void; act: (a: Action) => void; notify: typeof notify; botNow: () => boolean };
  }
}

async function init(): Promise<void> {
  const res = await fetch('data/cards.json');
  if (!res.ok) throw new Error(`Не удалось загрузить базу карт (${res.status})`);
  const data = (await res.json()) as CardsData;
  loadDatabase(data);
  assertScriptsComplete(Object.keys(DB.cards));
  onAutoInstall((state) => openModal(() => OV.installNowV(state)));
  onInstalled(() => openModal(() => OV.installedV()));
  initInstallBanner();
  render();
  initOutbox();
  initSocial();
  initProfile();
  initReplay();
  // плитка «Сид дня» на хабе показывает мутатор дня и мою попытку — грузим сразу, экран дня перечитает сам
  void loadDaily(repaintSocial);
  void loadMyBosses(repaintSocial);
  // уведомления устройства (игра по переписке): состояние подписки, свежий адрес — серверу; перерисовать и окно профиля
  onPushChange(() => {
    repaintSocial();
    if (modalOpen()) repaintModal();
  });
  void initPush();
  initCorr(repaintSocial);
  window.__K = { get G() { return st.G; }, ui, st, render, act, notify, botNow };
  precacheArt(data);
}

/** Офлайн: попросить service worker заранее скачать все картинки карт и жетонов (в фоне, по одной) */
function precacheArt(data: CardsData): void {
  if (!('serviceWorker' in navigator) || location.protocol === 'file:') return;
  const urls = new Set<string>();
  for (const c of data.cards) {
    urls.add(c.image);
    if (c.art) urls.add(c.art);
  }
  for (const t of data.traits) urls.add(t.image);
  for (const t of data.ddk) urls.add(t.image);
  navigator.serviceWorker.ready.then((reg) => reg.active?.postMessage({ type: 'precache', urls: [...urls] })).catch(() => {});
}
init().catch((e: unknown) => {
  console.error(e);
  $app.innerHTML = `<div class="pass"><div class="big">Ошибка загрузки</div><div class="sub">${e instanceof Error ? e.message : String(e)}</div></div>`;
});
